{
    "NAME": "Panoramica amministrativaLingua",
    "AdminOverview_Intro": "Seleziona un CME, un server di telefonia e una partizione per visualizzare le aree amministrative disponibili e il loro numero attuale.",
    "AdminOverview_Search_Helper": "La ricerca si applica ai conteggi visualizzati qui e viene applicata alla pagina di amministrazione selezionata.",
    "AdminOverview_State_Loading": "Caricamento",
    "AdminOverview_State_Error": "Impossibile caricare il conteggio più recente",
    "AdminOverview_State_NoTelephonyServer": "Nessun server di telefonia incluso",
    "AdminOverview_State_SelectTelephonyServer": "Seleziona un server di telefonia per caricare questo conteggio",
    "AdminOverview_State_SelectTelephonyServerAndPartition": "Seleziona un server di telefonia e una partizione per caricare questo conteggio",
    "AdminOverview_State_SelectPartition": "Seleziona una partizione specifica per visualizzare questo conteggio",
    "AdminOverview_State_MessagesLegacy": "Pagina di amministrazione legacy",
    "AdminOverview_State_DatabaseLegacy": "Pagina di amministrazione legacy",
    "AdminOverview_Tile_Cme_Title": "ECM",
    "AdminOverview_Tile_Cme_Subtitle": "Struttura dei servizi",
    "AdminOverview_Tile_Cme_Summary": "Formazione continua in medicina pediatrica",
    "AdminOverview_Tile_Cme_Aria": "Corsi ECM aperti",
    "AdminOverview_Tile_Telsys_Title": "Server di telefonia",
    "AdminOverview_Tile_Telsys_Subtitle": "Proprietà della piattaforma",
    "AdminOverview_Tile_Telsys_Summary": "Numero totale di server",
    "AdminOverview_Tile_Telsys_Aria": "Server di telefonia aperti",
    "AdminOverview_Tile_Partitions_Title": "Pareti divisorie",
    "AdminOverview_Tile_Partitions_Subtitle": "ambito della partizione",
    "AdminOverview_Tile_Partitions_Summary": "Pareti divisorie",
    "AdminOverview_Tile_Partitions_Aria": "Partizioni aperte",
    "AdminOverview_Tile_Users_Title": "Utenti",
    "AdminOverview_Tile_Users_Subtitle": "Accesso all'applicazione",
    "AdminOverview_Tile_Users_Summary": "Utenti",
    "AdminOverview_Tile_Users_Aria": "Utenti aperti",
    "AdminOverview_Tile_Devices_Title": "Dispositivi",
    "AdminOverview_Tile_Devices_Subtitle": "Inventario degli endpoint",
    "AdminOverview_Tile_Devices_Summary": "Dispositivi",
    "AdminOverview_Tile_Devices_Aria": "Dispositivi aperti",
    "AdminOverview_Tile_Devices_Extension": "Estensione",
    "AdminOverview_Tile_Devices_ExtensionTrunking": "Estensione (canalizzazione)",
    "AdminOverview_Tile_Devices_ExtensionHospitality": "Estensione (Settore alberghiero)",
    "AdminOverview_Tile_Devices_Groups": "Gruppi",
    "AdminOverview_Tile_Devices_AutoAttendant": "Auto Attendant",
    "AdminOverview_Tile_Agents_Title": "agenti",
    "AdminOverview_Tile_Agents_Subtitle": "Operazioni di coda",
    "AdminOverview_Tile_Agents_Summary": "agenti",
    "AdminOverview_Tile_Agents_Aria": "Agenti aperti",
    "AdminOverview_Tile_Directory_Title": "Elenco",
    "AdminOverview_Tile_Directory_Subtitle": "Contatti record",
    "AdminOverview_Tile_Directory_Summary": "Directory",
    "AdminOverview_Tile_Directory_Aria": "Open Directory",
    "AdminOverview_Tile_Codes_Title": "Codici",
    "AdminOverview_Tile_Codes_Subtitle": "Gestione del codice",
    "AdminOverview_Tile_Codes_Summary": "Codici",
    "AdminOverview_Tile_Codes_Aria": "Codici aperti",
    "AdminOverview_Tile_Recording_Title": "Registrazione",
    "AdminOverview_Tile_Recording_Subtitle": "Integrazioni",
    "AdminOverview_Tile_Recording_Summary": "Registrazioni",
    "AdminOverview_Tile_Recording_Aria": "Registrazione pubblica",
    "AdminOverview_Tile_Messages_Title": "Messaggi",
    "AdminOverview_Tile_Messages_Subtitle": "Strumenti legacy",
    "AdminOverview_Tile_Messages_Aria": "Messaggi aperti",
    "AdminOverview_Tile_Database_Title": "Schermata",
    "AdminOverview_Tile_Database_Subtitle": "Strumenti legacy",
    "AdminOverview_Tile_Database_Aria": "Database aperto"
}